import React, { useState } from 'react';

import moment from 'moment';

import SectorFlight from 'components/Cards/DataCardExchangeFlights/components/SectorFlight';
import CollapsibleDetail from 'components/Cards/DataCardGroupedFlights/FlightOption/CollapsibleDetail';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Sector } from 'models/sector';
import { TravelStatus } from 'models/travelStatus';
import TravelTag from 'screens/components/TravelRequested/components/TravelTag';
import { splitDate } from 'utils/generic';

import {
  Container,
  DropdownChevron,
  Header,
  IconArrival,
  IconDepart,
  Title,
  ToggleDetails,
  Divider,
  CancelButton,
  Wrapper,
} from './styles';

type Props = {
  isDeparture?: boolean;
  sector: Sector;
  status: TravelStatus;
  canCancel?: boolean;
  onCancel?: () => void;
};
const FlightDetails = ({ isDeparture = true, sector, status, canCancel = false, onCancel }: Props) => {
  const { t } = useStoreTranslation();
  const [open, setOpen] = useState(false);

  const formatDate = (date: string) => moment(splitDate(date)).format('dddd, DD MMM');

  return (
    <Container onClick={() => setOpen(!open)}>
      <Header>
        <Title>
          {isDeparture ? (
            <>
              <IconDepart /> {t('flightDetails.section.detail.flight.departure')}
            </>
          ) : (
            <>
              <IconArrival /> {t('flightDetails.section.detail.flight.arrival')}
            </>
          )}{' '}
          {formatDate(sector.flights[0].departureDate)}
        </Title>
        <ToggleDetails $detailsOpen={open}>
          <DropdownChevron />
        </ToggleDetails>
      </Header>
      <TravelTag status={status} />
      <Divider />
      {!open && <SectorFlight sector={sector} hideArrow />}
      {canCancel && (
        <CancelButton
          onClick={() => {
            if (onCancel) onCancel();
          }}
        >
          {t('flightDetails.section.detail.flight.cancel')}
        </CancelButton>
      )}
      {open && (
        <Wrapper>
          <CollapsibleDetail expanded={open} flights={sector.flights} totalDuration={sector.totalDuration} />
        </Wrapper>
      )}
    </Container>
  );
};

export default FlightDetails;
